import { render } from "./TopBarView.vue?vue&type=template&id=486600ce&scoped=true"
import script from "./TopBarView.vue?vue&type=script&lang=js"
export * from "./TopBarView.vue?vue&type=script&lang=js"

import "./TopBarView.vue?vue&type=style&index=0&id=486600ce&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-486600ce"]])

export default __exports__